import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-833">
      <HeroSection data-id="element-834" />
      <PainSection data-id="element-835" />
      <TruthSection data-id="element-836" />
      <ProductPresentation data-id="element-837" />
      <ContentBreakdown data-id="element-838" />
      <BenefitsSection data-id="element-839" />
      <TestimonialsSection data-id="element-840" />
      <ForYouSection data-id="element-841" />
      <GuaranteeSection data-id="element-842" />
      <BonusSection data-id="element-843" />
      <ValueStack data-id="element-844" />
      <FAQSection data-id="element-845" />
      <ImpactPhrases data-id="element-846" />
      <Footer data-id="element-847" />
    </div>;
}